import http from '../config'
const questionnaire = {
  getQuestionList() {
    return http({
      url: 'pylori/questions'
    })
  },
  submitAnswer(params) {
    return http({
      url: 'pylori/questions',
      method: 'POST',
      params
    })
  },
  getReportDetail() {
    return http({
      url: 'pylori/question/result'
      // withoutLogin: true
    })
  },
  getUserTestRecord() {
    return http({
      url: 'pylori/question/hasRecord',
      withoutLogin: true
    })
  },

  // 秃头测评API
  getBaldQuestionList() {
    return http({
      url: 'activity/baldPlan/questionList'
    })
  },
  submitBaldAnswer(data) {
    return http({
      url: 'activity/baldPlan/submitQuestionnaire',
      method: 'POST',
      data
    })
  }
}

export default questionnaire
